import { c as getDateTimeFormat } from './formatDate-BIw3YDwX-BIw3YDwX.js';

const getTimeOptions = ({
  timezone
}) => ({
  hour: 'numeric',
  hour12: true,
  minute: 'numeric',
  timeZoneName: 'short',
  timeZone: timezone
});

/**
 * @param {Date} date The date to format.
 * @param {string} locale A string with a BCP 47 language tag, or an array of such strings.
 * @param {string} timezone The time zone to use (e.g. America/New_York).
 * The default is the runtime's default time zone.
 */
const formatTime = getDateTimeFormat(getTimeOptions);

export { formatTime as f, getTimeOptions as g };
//# sourceMappingURL=formatTime-BfS0XKKR-BVTVy2gV.js.map
